import axios from 'axios';

const API_BASE_URL = 'https://online.ep-scan.nl/api';

// Create shared Axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add global 401 interceptor
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem('access_token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Attach token to every request (using request interceptor)
api.interceptors.request.use(config => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const login = async ({ email, password }) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
};

export const getUsers = async (params = {}) => {
    const response = await api.get('/admin/users', { params });
    return response.data;
};

export const deleteUser = async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
};

export const createUser = async (userData) => {
    const response = await api.post('/admin/users', userData);
    return response.data;
};

export const getExcelFiles = async (params) => {
    const response = await api.get('/admin/excel', { params });
    return response.data;
};

export const uploadExcelFile = async (formData) => {
    const response = await api.post('/admin/excel', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

export const deleteExcelFile = async (id) => {
    const response = await api.delete(`/admin/excel/${id}`);
    return response.data;
};

export const userExcelFileList = async () => {
    const response = await api.get('/user-excel-list');
    return response.data;
};

export const saveSelectedEntity = async (id) => {
    const response = await api.get(`/save-selected-entity/${id}`);
    return response.data;
};

export const userSelectedEntityList = async () => {
    const response = await api.get('/user-excel-entity-list');
    return response.data;
};

export const updateTool = async ({ id, tool_id }) => {
    const response = await api.post('/update-tool', { id, tool_id });
    return response.data;
};

export const fetchEntityTabs = async (entity_id) => {
    const response = await api.get(`/read-entity-data/${entity_id}`);
    return response.data;
};

export const deleteUserEntity = async (entity_id) => {
    const response = await api.delete(`/user-entity/${entity_id}`);
    return response.data;
};

export const downloadUserExcel = async (entity_id) => {
    const response = await api.get(`/download-excel-template/${entity_id}`, {
        responseType: 'blob',
    });
    return response;
};

export const getWordFiles = async (params) => {
    const response = await api.get('/admin/word', { params });
    return response.data;
};

export const uploadWordFile = async (formData) => {
    const response = await api.post('/admin/word', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
};

export const updateEntityForm = async (formData, entityId) => {
    const response = await api.post(`/update-entity-form/${entityId}`, formData);
    return response.data;
};

export const downloadDocFile = async (activeDocsEntityId, entityId) => {
    const response = await api.get(`/generate-docs/${activeDocsEntityId}/${entityId}`, {
        responseType: 'blob'
    });
    return response;
};

export const deleteWordFile = async (id) => {
    const response = await api.delete(`/admin/word/${id}`);
    return response.data;
};

export const fetchTemplateFile = async () => {
    const response = await api.get('/docs-template-list');
    return response.data;
};


export const excelEntitySearch = async (searchTerm) => {
    const response = await api.get(`/search-excel-entities?search=${encodeURIComponent(searchTerm)}`);
    return response.data;
};
